import { useTranslation } from 'react-i18next';

import { Box } from '@sternum/styled-system';
import { Button } from '@sternum/ui';
import { Icon } from '@sternum/web/components';
import { namespaces } from '@sternum/web/services/i18n';

import { DashboardsEmptyStyled, Description, Title } from './EmptyState.styles';

export interface EmptyStateProps {
  onAddDashboard?: () => unknown;
}

export function EmptyState({ onAddDashboard }: EmptyStateProps) {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  return (
    <DashboardsEmptyStyled>
      <Title>{t('emptyBoardCreateDashboards')}</Title>
      <Description>{t('emptyBoardDescription')}</Description>
      <Box />
      <Button variant="text-secondary" leftIcon={<Icon type="PlusIcon" />} onClick={onAddDashboard}>
        {t('emptyBoardAddDashboardButton')}
      </Button>
    </DashboardsEmptyStyled>
  );
}
